'use es6';

import { Map as ImmutableMap } from 'immutable';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import DSContext from './DSContext';
import PropTypes from 'prop-types';
import { Children, cloneElement, PureComponent } from 'react';
import withDSContext from './withDSContext';
const defaultFetcherStatus = ImmutableMap({
  hasMore: false,
  offset: 0
});
class DSConnector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: ImmutableMap()
    };
    this.fetchMore = this.fetchMore.bind(this);
    this.fetcherStatus = ImmutableMap();
  }
  componentDidMount() {
    const {
      DSData: {
        data
      }
    } = this.props;
    this.parseNewData(data);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.DSData.data !== this.props.DSData.data) {
      this.parseNewData(this.props.DSData.data);
    }
  }
  fetchMore(args) {
    const {
      variables: {
        assetFamily,
        batchUpdate,
        ids,
        query
      }
    } = args;
    const {
      DSData
    } = this.props;
    const fetcherStatus = this.fetcherStatus.get(assetFamily) || defaultFetcherStatus;
    return DSData.fetch({
      batchUpdate,
      ids,
      hasMore: fetcherStatus.get('hasMore'),
      offset: fetcherStatus.get('offset'),
      query
    }, assetFamily)
    // We might want to add an error handler here at some point
    .then(({
      data,
      hasMore,
      offset
    }) => {
      this.fetcherStatus = this.fetcherStatus.setIn([assetFamily, 'hasMore'], hasMore).setIn([assetFamily, 'offset'], offset);
      return data;
    }).catch(rethrowError);
  }
  parseNewData(newData) {
    // Eventually we'll have to do more here to get the correct data but for
    // now I'm just setting it to the new data.
    this.setState({
      data: newData
    });
  }
  render() {
    const consumer = Children.only(this.props.children);
    const {
      data
    } = this.state;
    return /*#__PURE__*/cloneElement(consumer, {
      data,
      fetchMore: this.fetchMore
    });
  }
}
DSConnector.propTypes = Object.assign({
  children: PropTypes.node.isRequired
}, DSContext.propTypes);

// Allow the base adapter to customize the connector, required for reference
// resolvers but we may be able to move it if we switch base adapters
export default withDSContext(DSConnector);